import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';

export interface JointHolderInvitationsExitState {
  exitedWithoutSigning: boolean;
}

const emptyState = (): JointHolderInvitationsExitState => ({
  exitedWithoutSigning: false,
});

@Injectable({
  providedIn: 'root',
})
export default class JointHolderInvitationsExitStore extends ComponentStore<JointHolderInvitationsExitState> {
  constructor() {
    super(emptyState());
  }

  saveExitedWithoutSigning(): void {
    this.patchState(() => ({exitedWithoutSigning: true}));
  }

  hasExitedWithoutSigning(): boolean {
    return this.get().exitedWithoutSigning;
  }

  reset(): void {
    this.patchState(() => emptyState());
  }
}
